/**
 * Cadastro público.
 *
 * O formulário de signup criava a organização e inseria o próprio usuário
 * como admin (user_role_id 1 / role 'admin') direto do navegador, com a anon
 * key. Qualquer visitante abria uma conta administrativa sem aprovação de
 * ninguém. O cadastro passa a ser operação de administrador — quem entra é
 * criado por um admin da organização, via createOrganizationMember.
 *
 * Para reabrir temporariamente (migração de base, demonstração), defina
 * VITE_ALLOW_PUBLIC_SIGNUP=true no ambiente. O padrão é fechado, inclusive
 * quando a variável não existe.
 */
export const PUBLIC_SIGNUP_ENABLED =
  import.meta.env.VITE_ALLOW_PUBLIC_SIGNUP === 'true';
